export default {
  // FAILED_CONNECTION_NOTIFICATION: '',
  // Do not localize {Retry}; it is a placeholder for "Retry". English translation should be, "Send failed. Retry."
  SEND_FAILED_KEY: `wysłanie nieudane, {Retry}.`,
  // SLOW_CONNECTION_NOTIFICATION: '',
  Chat: 'Czat',
  // 'Download file': '',
  // 'Microphone off': '',
  // 'Microphone on': '',
  'Listening…': 'Słuchanie…',
  Retry: 'wyślij ponownie',
  Send: 'Wyślij',
  Sending: 'wysyłanie',
  Speak: 'Mów',
  'Starting…': '',
  Tax: 'Podatek',
  Total: 'Razem',
  'Type your message': 'Wpisz swoją wiadomość',
  'Upload file': 'Wyślij plik',
  VAT: 'VAT'
  // 'X minutes ago': 'X minut temu'
};
